import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  otpSend,
  otpValidate,
  // rewardIdAuthenticationList,
} from "../../store/auth/actions";
import {
  Button,
  Card,
  Divider,
  Form,
  Image,
  Input,
  Space,
  Tooltip,
  Typography,
} from "antd";
import {
  MobileTwoTone,
  ArrowRightOutlined,
  EditOutlined,
} from "@ant-design/icons";
import "./auth.css";
import logo from "../../assets/images/Logo copy.png";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
// import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import axios from "axios";
import api from "../../helpers";
// import { BsPenFill } from "react-icons/bs";

const { Title } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { id } = useParams();

  console.log(id, "id");
  //state values
  const [loginData, setLoginData] = useState({
    phoneNumber: "",
    secretKey: "",
  });

  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      phoneNumber: /^[0-9]*$/,
      secretKey: /^[0-9]*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setLoginData({
          ...loginData,
          [name]: value,
        });
      }
    } else {
      setLoginData({
        ...loginData,
        [name]: value,
      });
    }
  };

  //Otp section

  const [otpValue, setOtpValue] = useState("");
  const [rewardResponse, setRewardResponse] = useState("");
  const [rewardEmpty, setRewardEmpty] = useState(false);
  const [otpSentTime, setOtpSentTime] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [mobileEdit, setMobileEdit] = useState(false);
  const [error, setError] = useState(false);
  const expirationTime = 60;

  useEffect(() => {
    let timer;
    if (otpSentTime) {
      timer = setInterval(() => {
        const currentTime = new Date().getTime();
        const elapsedTime = Math.floor((currentTime - otpSentTime) / 1000);
        const timeRemaining = expirationTime - elapsedTime;

        if (timeRemaining >= 0) {
          setTimeLeft(timeRemaining);
        } else {
          clearInterval(timer);
          setTimeLeft(0);
          setOtpValue("");
          setIsExpired(true);
        }
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [otpSentTime]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const [displayButton, setButtonDisplay] = useState("");
  const [visible, setVisible] = useState(true);
  const [userStatus, setUserStatus] = useState("");

  // State maintenance

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //Login functionality

  const handleOTPbtn = async () => {
    if (!isEmpty(loginData.phoneNumber)) {
      const otp = {
        mobile: loginData.phoneNumber,
      };

      dispatch(otpSend(otp));

      // await api
      //   .post("/mobile-check", otp)
      //   .then((res) => res.data)
      //   .catch((error) => Promise.reject(error));
      console.log(otp, "otp");
      setButtonDisplay(true);
      setVisible(false);
      setOtpValue("");
      setError("");
      sendOtp();
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };
  const referralValue = localStorage.getItem("rewardResponse");
  console.log(referralValue, "referralValue");
  const registerPagePath =
    referralValue && referralValue
      ? `/create-account/${referralValue}`
      : rewardResponse &&
        rewardResponse.data &&
        rewardResponse.data.referral_link_code
      ? `/create-account/${rewardResponse.data.referral_link_code}`
      : id !== undefined && `/create-account/${id}`;
  // : `/create-account`;
  const loginPagePath =
    // rewardResponse &&
    // rewardResponse.data &&
    // rewardResponse.data.referral_link_code
    //   ? `/login/${rewardResponse.data.referral_link_code}`
    //   :
    id !== "login" && id !== undefined && `/login/#`;

  console.log(id, "id");

  const mobileValidations = () => {
    if (simpleValidator.current.allValid()) {
      const user = {
        mobile: loginData.phoneNumber,
        otp: otpValue,
      };
      // dispatch(otpValidate(user));
      // await axios.get(
      //   "https://pmtrewards.mequalstech.com/api/sanctum/csrf-cookie",
      //   {
      //     withCredentials: true,
      //   }
      // );
      api
        .post("/Api/validate_otp", user)
        .then((res) => {
          // res.data;
          const user_status =
            res.data && res.data.data && res.data.data.user_status
              ? parseInt(res.data.data.user_status)
              : "";
          const regMobileNo =
            res.data && res.data.data && res.data.data.regMobileNo
              ? parseInt(res.data.data.regMobileNo)
              : "";
          console.log(res.data, "res");
          if (user_status === 0) {
            setUserStatus(user_status);

            localStorage.setItem("mobileNo", regMobileNo);
            if (isEmpty(rewardResponse)) {
              setRewardEmpty(true);
              localStorage.setItem("reward", "");
            } else {
              localStorage.setItem("reward", JSON.stringify(rewardResponse));
            }
            history.push(registerPagePath);
            setTimeout(() => {
              localStorage.setItem("rewardResponse", "");
            }, 1500);
          } else {
            toast.error("You are a existing user, kindly login your account");
          }
          return res.data;
        })
        .catch((error) => {
          setError(error);
          return Promise.reject(error);
        });
      console.log(otpValidate(), "api");
      console.log(user, "user");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const sendOtp = () => {
    const currentTime = new Date().getTime();
    setOtpSentTime(currentTime);
    setTimeLeft(expirationTime);
    setIsExpired(false);
  };

  console.log(userStatus, "userStatus");
  const isInitialRender = useRef(true);

  console.log(id, "id");

  console.log(rewardResponse, "rewardResponse");

  useEffect(() => {
    setTimeout(() => {
      if (
        isInitialRender.current &&
        !isEmpty(id) &&
        id !== "login" &&
        !rewardEmpty
      ) {
        api
          .post("/Api/referral_code_verify", { referral_code: id })
          .then((res) => {
            console.log(res.data, "response");
            setRewardResponse(res.data);
            localStorage.setItem(
              "rewardResponse",
              res.data.data.referral_link_code
            );
            return res.data;
          })
          .catch((error) => {
            console.log(error, "error");
            // toast.error(error ? error.response.data.message : "error");
            return Promise.reject(error);
          });
        isInitialRender.current = false;
        // dispatch(rewardIdAuthenticationList({ referral_code: id }));
      }
      //  else if (isEmpty(rewardResponse)) {
      //   isInitialRender.current = false;
      //   setRewardResponse("");
      //   // dispatch(rewardIdAuthenticationList({ referral_code: id }));
      // }
      // if (id === "login" || id === "#" || id === undefined)
      else if (
        (id === "login" || id === "#" || id === undefined) &&
        isEmpty(referralValue)
      ) {
        history.push({
          pathname: "/login/#",
          state: "without-referral",
        });
        localStorage.setItem("rewardResponse", "");
      }
    }, 1200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex-container" style={{ overflow: "hidden" }}>
      <Card className="login-main-card-details" style={{ flex: "1" }}>
        <div className="login-main-image flex justify-center">
          <div className="mt-[70px] bg-[transparent]">
            {/* <Image
              src={logo}
              preview={false}
              width={180}
              height={60}
              className="rounded-lg"
            /> */}
            <div className="mt-2">
              <h1
                style={{
                  padding: "7px",
                  borderRadius: "10px",
                  border: "none",
                  background: "#69000070",
                  // boxShadow: "1px 1px 13px 1px #8d8d8d8f",
                }}
                className="text-[20px] font-bold text-[#ffffff]"
              >
                A Loyalty Program that pays you back
              </h1>
            </div>
          </div>

          {/* <Image
            src={logoOverlay}
            preview={false}
            className="logo-overlay"
          /> */}
        </div>
      </Card>

      <Card
        style={{
          flex: "1",
          margin: "0px 0px",
          backgroundColor: "#f1f1f1",
          height: "auto",
          overflow: "hidden",
        }}
      >
        <div className="font-sans login-form-card-details">
          <Image
            src={logo}
            preview={false}
            style={{
              alignContent: "flex-start",
              width: "150px",
              height: "75px",
              borderRadius: "2px",
            }}
          />
        </div>

        <div>
          <Title
            level={4}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              margin: "30px 0px 5px 32px",
              fontSize: "22px",
              fontWeight: "800", // Semi-bold

              fontFamily: "Roboto, sans-serif",
            }}
          >
            Get Started
          </Title>
        </div>

        <div style={{ textAlign: "left" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "32px",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            <ArrowRightOutlined
              style={{ fontSize: "14px", marginRight: "4px" }}
            />
            <Typography.Text
              style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}
            >
              New to Plan MI trip? Register by providing your mobile number
            </Typography.Text>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "32px",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            <ArrowRightOutlined
              style={{ fontSize: "14px", marginRight: "4px" }}
            />
            <Typography.Text
              style={{ fontSize: "15px", fontFamily: "Roboto, sans-serif" }}
            >
              Know more about the Program
            </Typography.Text>
          </div>
        </div>
        <div className="w-[100] text-center text-[red]">
          {!isEmpty(error) ? error.response.data.message : ""}
        </div>
        <Form
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          style={{ margin: "16px 0px", marginTop: 26 }}
        >
          <Form.Item
            name={"Number"}
            rules={[{ message: "Enter Mobile no" }]}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "28px",
              position: "relative",
            }}
          >
            <Space.Compact className="flex flex-col">
              <div className="">
                <Input
                  maxLength={10}
                  size="large"
                  name="phoneNumber"
                  className="register-edit-input-fields"
                  inputMode="numeric"
                  disabled={
                    mobileEdit === true
                      ? false
                      : loginData.phoneNumber.length === 10
                      ? true
                      : false
                  }
                  placeholder="Enter Your Mobile Number"
                  value={loginData.phoneNumber}
                  onChange={(e) => handlePhoneNumberChange(e)}
                  prefix={<MobileTwoTone />}
                />
                {loginData.phoneNumber.length === 10 ? (
                  <Tooltip
                    placement="topLeft"
                    title={"Click the Edit to update the mobile no"}
                    className="ml-1 register-edit-icon"
                  >
                    {" "}
                    <EditOutlined
                      onClick={() => setMobileEdit(!mobileEdit)}
                      className="text-[18px]"
                    />{" "}
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
              <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "phoneNumber",
                  loginData.phoneNumber,
                  "required"
                )}
              </p>
            </Space.Compact>
          </Form.Item>

          {visible && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Button
                style={{
                  width: "450px",
                  height: "45px",
                  marginLeft: "28px",
                  backgroundColor: "#7b7b7b",
                  color: "whitesmoke",
                }}
                disabled={
                  (id &&
                    rewardResponse &&
                    rewardResponse.status_code === 200) ||
                  isEmpty(rewardResponse)
                    ? false
                    : true
                }
                onClick={handleOTPbtn}
              >
                Send OTP
              </Button>
            </div>
          )}

          {displayButton && (
            <div>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginLeft: "32px",
                  fontWeight: "bold",
                  fontSize: "14px",
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Enter OTP Sent to register mobile no
              </Typography>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginLeft: "32px",
                }}
              >
                {timeLeft !== null && !isExpired && (
                  <div>({formatTime(timeLeft)})</div>
                )}
                {isExpired && (
                  <div style={{ color: "red" }} className="flex">
                    OTP has expired. Please request a new one.
                    <p
                      className="underline text-[#000000] ml-2 cursor-pointer"
                      onClick={handleOTPbtn}
                    >
                      Resend OTP
                    </p>
                  </div>
                )}
              </div>

              <Form.Item
                name={"otp"}
                className="login-otp-fields"
                // rules={[{ required: true, message: "Enter OTP" }]}
              >
                <Input.OTP
                  variant="filled"
                  size="large"
                  name="otpValue"
                  value={otpValue}
                  onChange={(e) => setOtpValue(e)}
                />
                <p className="text-start mt-1 text-[red] text-[12px]">
                  {simpleValidator.current.message(
                    "otpValue",
                    otpValue,
                    "required"
                  )}
                </p>
              </Form.Item>

              <Form.Item
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginLeft: "28px",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-input-fields"
                  style={{
                    backgroundColor: "#7b7b7b",
                    color: "whitesmoke",
                  }}
                  onClick={mobileValidations}
                >
                  <Link
                    to={{
                      pathname: userStatus === 0 ? registerPagePath : "/",
                      state: {
                        mobileNo: loginData.phoneNumber
                          ? loginData.phoneNumber
                          : "",
                      },
                    }}
                    className="w-[100%]"
                  >
                    Continue
                  </Link>
                </Button>
              </Form.Item>
            </div>
          )}
          <div className="login-route">
            <Divider className="w-[100%] mb-4">Or</Divider>

            <div className="font-semibold w-[100%] mt-4">
              {/* Existing User ?{" "} */}

              {/* <div
                to={{
                  pathname: loginPagePath,
                }}
                onClick={handleNavigate}
                style={{
                  border: "1px dashed #3498db",
                }}
                className="text-[#3498db] rounded-md p-1 pl-10 pr-10 w-[70%]"
              >
                Login
              </div> */}
              <Link
                to={{
                  pathname: loginPagePath,
                  state: "without-referral",
                }}
                style={{
                  border: "1px dashed #3498db",
                }}
                onClick={() => localStorage.setItem("rewardResponse", "")}
                className="text-[#3498db] rounded-md p-1 pl-10 pr-10 w-[70%]"
              >
                Login
              </Link>
            </div>
          </div>
        </Form>
      </Card>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          fontSize: "11px",
        }}
        theme="colored"
      />
    </div>
  );
};

export default Login;
